import { ListEntityField } from "models/list-entity-field";
import * as yup from "yup";
import { EntityCollectionValue } from "models/list-user-entity-collection-value";
import { toFormValues } from "./form";

export const buildUserValidationSchema = (
  listEntityFields: ListEntityField[],
) => buildValidationSchema(listEntityFields, false);

export const buildAdminValidationSchema = (
  listEntityFields: ListEntityField[],
) => buildValidationSchema(listEntityFields, true);

const buildValidationSchema = (
  listEntityFields: ListEntityField[],
  isAdmin: boolean,
) => {
  const obj: any = {};
  listEntityFields.forEach((field) => {
    switch (field.datatype) {
      case "text":
        obj[field.uuid] = buildTextSchema(field, isAdmin);
        break;
      case "email":
        obj[field.uuid] = buildEmailSchema(field, isAdmin);
        break;
      case "dropdown":
        obj[field.uuid] = buildDropdownSchema(field, isAdmin);
        break;
      case "check":
        obj[field.uuid] = buildCheckSchema(field, isAdmin);
        break;
      case "ssn":
        obj[field.uuid] = buildSSNSchema(field, isAdmin);
        break;
      case "phone":
        obj[field.uuid] = buildPhoneSchema(field, isAdmin);
        break;
      case "date":
        obj[field.uuid] = buildDateSchema(field, isAdmin);
        break;
      case "datetime":
        obj[field.uuid] = buildDateTimeSchema(field, isAdmin);
        break;
      default:
        throw new Error(`Unknown datatype: ${field.datatype}`);
    }
  });
  return yup.object(obj).required();
};

export const buildDefaultValues = (
  listEntityFields: ListEntityField[],
  entityCollectionValues: EntityCollectionValue[],
) => {
  const defaultValues = toFormValues(entityCollectionValues, listEntityFields);
  return defaultValues;
};

const isRequired = (field: ListEntityField, isAdmin: boolean) => {
  // if admin, remove requirement
  if (isAdmin === true) {
    return false;
  }

  // if the field is not for user
  if (field.admin_only === true) {
    return false;
  }

  // use flag
  return field.required;
};

const buildTextSchema = (field: ListEntityField, isAdmin: boolean) => {
  let schema = yup.string();
  if (field.required && !isAdmin) {
    schema = schema.validateRequired();
  }
  return schema;
};

const buildEmailSchema = (field: ListEntityField, isAdmin: boolean) => {
  let schema = yup.string();
  if (isRequired(field, isAdmin)) {
    schema = schema.validateRequired();
  }
  return schema.validateEmail();
};

const buildSSNSchema = (field: ListEntityField, isAdmin: boolean) => {
  let schema = yup.string();
  if (isRequired(field, isAdmin)) {
    schema = schema.validateRequired();
  }
  return schema.validateSsn();
};

export const buildPhoneSchema = (field: ListEntityField, isAdmin: boolean) => {
  let schema = yup.string();
  if (isRequired(field, isAdmin)) {
    schema = schema.validateRequired();
  }
  return schema.validatePhone();
};

const buildDropdownSchema = (field: ListEntityField, isAdmin: boolean) => {
  let schema = yup.string();
  if (isRequired(field, isAdmin)) {
    schema = schema.validateRequired();
  }

  return schema;
};

export const buildCheckSchema = (field: ListEntityField, isAdmin: boolean) => {
  let schema = yup.string();
  if (isRequired(field, isAdmin)) {
    schema = schema.validateRequired();
  }
  return schema;
};

export const buildDateSchema = (field: ListEntityField, isAdmin: boolean) => {
  let schema = yup.string();
  if (isRequired(field, isAdmin)) {
    schema = schema.validateRequired();
  }
  return schema;
};

export const buildDateTimeSchema = (
  field: ListEntityField,
  isAdmin: boolean,
) => {
  let schema = yup.string();
  if (isRequired(field, isAdmin)) {
    schema = schema.validateRequired();
  }
  return schema;
};
